
import { wsClient } from './websocketClient';

type EmoteCallback = (playerId: number | string, emoteId: string, emoteType: 'premium' | 'animated') => void;

class EmoteService {
    private listeners: EmoteCallback[] = [];

    constructor() {
        this.init();
    }

    private init() {
        // Listen for incoming emote messages from WebSocket
        wsClient.onMessage((msg) => {
            if (msg.type === 'EMOTE') {
                // Received emote from server (remote player)
                this.emitEmote(msg.playerId, msg.emoteId, (msg as any).emoteType || 'premium', false);
            }
        });
    }

    // Triggered by UI (local player) or WebSocket (remote player)
    public emitEmote(playerId: number | string, emoteId: string, emoteType: 'premium' | 'animated', isLocal: boolean = true) {
        // 1. Notify local subscribers (to show bubble)
        this.listeners.forEach(cb => cb(playerId, emoteId, emoteType));

        // 2. If local, send to server
        if (isLocal) {
            wsClient.send({ type: 'EMOTE', emoteId, emoteType });
        }
    }

    public onEmote(callback: EmoteCallback) {
        this.listeners.push(callback);
        return () => {
            this.listeners = this.listeners.filter(l => l !== callback);
        };
    }
}

export const emoteService = new EmoteService();
